import React from "react";

import { TicketList } from "@components/Ticket";

export default function TicketIndex() {
  return <TicketList />;
}
